import { z } from "zod";

export { payment as serverResponse } from "../validators";

export const verificationErrorResponse = z.object({
  code: z.literal("50133"),
});
